import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { FeatureToggleService } from './services/feature-toggle.service';
import { FeatureToggleStateService } from './feature-toggle-state.service';
import { featureToggleReducers, stateName } from './store';
import { GroupEffects } from './store/groups';
import { LicenseEffects } from './store/licenses';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(stateName, featureToggleReducers),
    EffectsModule.forFeature([GroupEffects, LicenseEffects]),
  ],
  providers: [FeatureToggleService, FeatureToggleStateService],
})
export class FeatureToggleModule {}
